import { render, staticRenderFns } from "./LotteryWinnerCard.vue?vue&type=template&id=a4b8b8b0&scoped=true&lang=pug&"
import script from "./LotteryWinnerCard.vue?vue&type=script&lang=js&"
export * from "./LotteryWinnerCard.vue?vue&type=script&lang=js&"
import style0 from "./LotteryWinnerCard.vue?vue&type=style&index=0&id=a4b8b8b0&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b8b8b0",
  null
  
)

export default component.exports